import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable, tap } from "rxjs";
import { type Application, type UpdateApplicationInput } from "src/app/schema";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class ApplicationService {
	private readonly _httpClient = inject(HttpClient);

	public updateApplication(
		application: UpdateApplicationInput,
	): Observable<Application> {
		return this._httpClient.put<Application>(
			`${environment.applicationsEndpoint}/application`,
			application,
		);
	}

	public approveApplication(applicationId: string): Observable<Application> {
		console.log("Approving application");
		return this._httpClient
			.post<Application>(
				`${environment.applicationsEndpoint}/applications/${applicationId}/approve`,
				{},
			)
			.pipe(tap((response) => console.log(response)));
	}

	public rejectApplication(applicationId: string): Observable<Application> {
		return this._httpClient.post<Application>(
			`${environment.applicationsEndpoint}/applications/${applicationId}/reject`,
			{},
		);
	}

	public assignApplication(
		applicationId: string,
		userId: string,
	): Observable<Application> {
		return this._httpClient.post<Application>(
			`${environment.applicationsEndpoint}/applications/${applicationId}/assign/${userId}`,
			{},
		);
	}

	public unassignApplication(applicationId: string): Observable<Application> {
		return this._httpClient.post<Application>(
			`${environment.applicationsEndpoint}/applications/${applicationId}/unassign`,
			{},
		);
	}
}
